// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"151":"c873dabd56b5e652","4112":"a3ede44e6a0beb25","4817":"a101d48440782d5f","6860":"c4724a1f9aa04a09","7855":"f25522d4178f131d","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};